export default __webpack_public_path__ + "static/media/(36).c9312096.jpg";